import "@fontsource-variable/plus-jakarta-sans";

import { routes } from "@app-setup:routes";
import { ErrorPage } from "@components:ErrorPage";
import { NullComponent } from "@components:Null";
import { ScrollToTopButton } from "@components:ScrollToTopButton";
import { Toaster } from "@components:Toaster";
import { queryClient } from "@libs:react-query";
import { AuthLoader } from "@libs:react-query-auth";
import { Box, CircularProgress, ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { QueryClientProvider } from "@tanstack/react-query";
import * as React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { RouterProvider } from "react-router";

import { themes } from "@:themes";

export const AppProvider = () => {
  return (
    <React.Suspense
      fallback={
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100vw",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </Box>
      }
    >
      <ThemeProvider theme={themes}>
        <LocalizationProvider dateAdapter={AdapterLuxon}>
          <ErrorBoundary FallbackComponent={ErrorPage}>
            <QueryClientProvider client={queryClient}>
              <AuthLoader renderLoading={() => <NullComponent />}>
                <RouterProvider router={routes} />
                <ScrollToTopButton />
                <Toaster />
              </AuthLoader>
            </QueryClientProvider>
          </ErrorBoundary>
        </LocalizationProvider>
      </ThemeProvider>
    </React.Suspense>
  );
};
